import { workbookOptions, toDataURL } from './ooxml/workbook';
import { saveAs } from '@progress/kendo-file-saver';
import { validatePackage } from '@progress/kendo-vue-common';
import { packageMetadata } from './package-metadata';
/**
 * @hidden
 */
export default function saveExcel(exportOptions) {
    validatePackage(packageMetadata);
    var saveFn = function (dataURL) {
        if (exportOptions.onExportComplete) {
            exportOptions.onExportComplete.call(undefined, {
                dataURL: dataURL,
                options: exportOptions
            });
        }
        saveAs(dataURL, exportOptions.fileName, {
            forceProxy: exportOptions.forceProxy,
            proxyURL: exportOptions.proxyURL
        });
    };
    var options = workbookOptions(exportOptions);
    toDataURL(options).then(saveFn);
}
